import ajax from './http'

const apis = {
    user_login: (params) => ajax('post', '/user/login', params),
    user_permission: (params) => ajax('get', '/user/get_menu', params),
    user_info: (params) => ajax('get', '/data/user_info', params),
    user_situation: (params) => ajax('get', '/data/user_situation', params),
    user_situation_stay: (params) => ajax('get', '/data/situation_stay', params),
    user_situation_range: (params) => ajax('get', '/data/user_situation_range', params),

    user_get_new_add: (params) => ajax('get', '/data/user_get/new_add', params),
    user_get_invite_new_add: (params) => ajax('get', '/data/user_get/new_invite', params),
    user_get_new_add_stay: (params) => ajax('get', '/data/user_get/new_add_stay', params),
    user_get_range_data: (params) => ajax('get', '/data/user_get/range_data', params),

    user_feature_stage_range: (params) => ajax('post', '/data/user_feature/stage_range', params),
    user_feature_province_range: (params) => ajax('post', '/data/user_feature/province_range', params),
    user_feature_active_stage_range: (params) => ajax('post', '/data/user_feature/active/stage_range', params),
    user_feature_active_province_range: (params) => ajax('post', '/data/user_feature/active/province_range', params),
    user_feature_consume_stage_range: (params) => ajax('post', '/data/user_feature/consume/stage_range', params),
    user_feature_consume_province_range: (params) => ajax('post', '/data/user_feature/consume/province_range', params),


    report_get_options:(params) => ajax('get', '/v2/report/get/report_filter_options', params, 'study'),
    report_get_data: (params) => ajax('get', '/v2/report/get/report_record/need', params, 'study'),
    report_get_be_reporter_status: (params) => ajax('get', '/v2/report/get/be_reporter/status', params, 'study'),
    report_report_check: (params) => ajax('post', '/v2/report/report_check', params, 'study'),
    report_get_user_detention_record: (params) => ajax('get', '/v2/report/get/user_detention_record', params, 'study'),
    report_get_be_reporter_last_status: (params) => ajax('get', '/v2/report/get/be_reporter/last_status', params, 'study'),
    report_update_detention_record: (params) => ajax('post', '/v2/report/update/detention_record', params, 'study'),

    report_list: (params) => ajax('get', '/report/list', params),
    report_process: (params) => ajax('post', '/report/handle', params),
    report_user_detention: (params) => ajax('get', '/report/user/detention/record', params),
    report_ban_user: (params) => ajax('post', '/v5/report/ban/user', params, 'study'),
    report_user_forbid: (params) => ajax('post', '/v5/user/forbid', params, 'study'),
    report_handle_clear_user_info: (params) => ajax('post', '/report/handle/clear_user_info', params),
    report_handle_clear_info: (params) => ajax('post', '/report/handle/clear_info', params),
     
    report_classroom_get_options:(params) => ajax('get', '/v2/report/get/classroom_report_filter_options', params, 'study'),
    report_classroom_get_be_reporter_status: (params) => ajax('get', '/v2/report/get/be_report_classroom/status', params, 'study'),
    report_classroom_get_data: (params) => ajax('get', '/v2/report/get/classroom_report_record/need', params, 'study'),
    report_classroom_get_user_detention_record: (params) => ajax('get', '/v2/report/get/classroom_detention_record', params, 'study'),
    report_classroom_get_be_reporter_last_status: (params) => ajax('get', '/v2/report/get/be_report_classroom/last_status', params, 'study'),
    report_classroom_update_detention_record: (params) => ajax('post', '/v2/report/update/classroom/detention_record', params, 'study'),

    feedback_get_options:(params) => ajax('get', '/v5/feedback/list', params, 'study'),
    feedback_process: (params) => ajax('post', '/v5/feedback/handle', params,'study'),
    feedback_award: (params) => ajax('post', '/v5/feedback/award', params,'study'),
    feedback_update: (params) => ajax('post', '/v5/feedback/update', params,'study'),
    feedback_send_single_message: (params) => ajax('post', '/im/send/single_message', params),
    feedback_user_award_record: (params) => ajax('get', '/feedback/user/award/record', params),


    faq_get_records_by_classify: (params) => ajax('get', '/v2/questions/'+params, {}, 'study'),
    faq_add_record: (params) => ajax('post', '/v2/faq/add_record', params, 'study'),
    faq_sort_records: (params) => ajax('post', '/v2/faq/sort/records', params, 'study'),
    faq_refresh_records: (params) => ajax('get', '/v2/faq/refresh/records', params, 'study'),
    faq_update_record: (params) => ajax('post', '/v2/faq/update/record', params, 'study'),
    faq_delete_record: (params) => ajax('post', '/v2/faq/delete/record', params, 'study'),


    get_oss: (params) => ajax('get', '/v1/oss_token', params, 'study'),
    calendar_get_text_records: (params) => ajax('get', '/v1/calendar/get/text_records', params),
    calendar_add_text_records: (params) => ajax('post', '/v1/calendar/add/text_record', params),
    calendar_update_text_records: (params) => ajax('post', '/v1/calendar/update/text_record', params),
    calendar_delete_text_record: (params) => ajax('post', '/v1/calendar/delete/text_record', params),

    calendar_get_img_classify: (params) => ajax('get', '/v1/calendar/get/img_classify', params),
    calendar_add_img_record: (params) => ajax('post', '/v1/calendar/add/img_record', params),
    calendar_get_img_records: (params) => ajax('get', '/v1/calendar/get/img_records', params),
    calendar_delete_img_record: (params) => ajax('post', '/v1/calendar/delete/img_record', params),

    message_record: (params) => ajax('get', '/im/get_msg_record', params),
    send_message_to_many: (params) => ajax('post', '/im/send_msg_to_many', params),

    active_add_school: (params) => ajax('post', '/active/add/new_school', params),
    get_school_list: (params) => ajax('get', '/active/get/school_list', params),
    update_school_info: (params) => ajax('post', '/active/update/school_info', params),


    co_user_property_shift: (params) => ajax('post', '/co_user/property/shift', params),
    co_user_property: (params) => ajax('get', '/co_user/property', params),

    
	// figure_shop_create: (params) => ajax('post', '/figure/clothes/shop/create', params, null, {}, true),
    image_shop_by_category: (params) => ajax('get', '/figure/image/shop/by_category', params, null),
    image_shop_update_title: (params) => ajax('post', '/figure/image/shop/update/title', params, null, {}, true),
    image_shop_upload: (params) => ajax('post', '/figure/image/shop/upload', params, null, {}, true),
    image_shop_sort_records: (params) => ajax('post', '/figure/image/shop/sort/records', params, null, {},true),
    image_shop_update_record: (params) => ajax('post', '/figure/image/shop/update/record', params, null, {}, true),
	image_shop_records: (params) => ajax('get', '/figure/image/shop/records', params, null),
	image_shop_all_records: (params) => ajax('get', '/figure/image/shop/all/records', params, null),
	image_shop_sort_top: (params) => ajax('post', '/figure/image/shop/sort/top', params),
    // faq_delete_record: (params) => ajax('post', '/v2/faq/delete/record', params, 'study'),

	figure_shop_get_clothes_tags:(params) => ajax('get', '/v3/clothes/tags', params, 'study'),
	figure_shop_post_clothes_bind_tag:(params) => ajax('post', '/v3/clothes/bind_tag', params, 'study'),
	figure_shop_create: (params) => ajax('post', 'v3/clothes/shop/create', params, 'study'),
	figure_shop_edit: (params) => ajax('post', 'v3/clothes/shop/edit', params, 'study'),
	figure_shop_update_record_json: (params) => ajax('post', '/figure/image/shop/update/record/images', params, null, {}, true),

	// 家具城
	furniture_centre_shop_records: (params) => ajax('get', '/furniture/image/shop/records', params, null),
	furniture_centre_shop_by_category: (params) => ajax('get', '/furniture/image/shop/by_category', params, null),
	furniture_centre_shop_upload: (params) => ajax('post', '/furniture/image/shop/upload', params, null, {}, true),
	furniture_centre_shop_create: (params) => ajax('post', 'furniture/shop/create', params, null, {}, true),
	furniture_centre_shop_edit: (params) => ajax('post', '/furniture/shop/edit', params, null, {}, true),
	furniture_shop_update_record: (params) => ajax('post', '/furniture/image/shop/update/record', params, null, {}, true),
	furniture_shop_update_record_json: (params) => ajax('post', '/furniture/image/shop/update/record/images', params, null, {}, true),
    furniture_image_shop_all_records: (params) => ajax('get', '/furniture/image/shop/all/records', params, null),
    
	// 家具城-装修家
	furniture_personal_centre_shop_records: (params) => ajax('get', '/personal/furniture/image/shop/records', params, null),
	furniture_personal_centre_shop_by_category: (params) => ajax('get', '/personal/furniture/image/shop/by_category', params, null),
	furniture_personal_centre_shop_upload: (params) => ajax('post', '/personal/furniture/image/shop/upload', params, null, {}, true),
	furniture_personal_centre_shop_create: (params) => ajax('post', '/personal/furniture/shop/create', params, null, {}, true),
	furniture_personal_centre_shop_edit: (params) => ajax('post', '/personal/furniture/shop/edit', params, null, {}, true),
	furniture_personal_shop_update_record: (params) => ajax('post', '/personal/furniture/image/shop/update/record', params, null, {}, true),
	furniture_personal_shop_update_record_json: (params) => ajax('post', '/personal/furniture/image/shop/update/record/images', params, null, {}, true),
	furniture_personal_image_shop_all_records: (params) => ajax('get', '/personal/furniture/image/shop/all/records', params, null),
    furniture_personal_image_shop_sort_top: (params) => ajax('post', '/personal/furniture/image/shop/sort/top', params, null, {}, true),
    

    // 餐馆-工厂
    restaurant_food_create: (params) => ajax('post', '/restaurant/food/create', params, null, {}, true),
    restaurant_food_records: (params) => ajax('get', '/restaurant/food/records', params, null),
    restaurant_food_update: (params) => ajax('post', '/restaurant/food/update', params, null, {}, true),
    restaurant_food_sort_top: (params) => ajax('post', '/restaurant/food/sort/top', params),
    
    // 通用接口
    user_use_record_create: (params) => ajax('post', '/user/use/record/create', params),
    
    // 辅助功能
    tool_user_info: (params) => ajax('get', '/co_user/info', params),
    tool_user_captcha: (params) => ajax('get', '/co_user/sms_code/record', params),
    tool_user_order_info: (params) => ajax('get', '/income/user/consumption/situation', params),
    tool_user_control_password_reset: (params) => ajax('post', '/co_user/control_password/reset', params),
    tool_user_personal_furniture_image_reset: (params) => ajax('post', '/personal/furniture/image/reset', params),
    tool_user_income_user_jewel_withhold: (params) => ajax('post', '/income/user/jewel/withhold', params),
    tool_user_income_currency_send: (params) => ajax('post', '/income/user/currency/send', params),
    
    // 即刻查询功能
    jk_user_text_info: (params) => ajax('get', '/co_user/text/info', params),
    jk_user_text_reset: (params) => ajax('post', '/co_user/text/reset', params),
    
    // 用户分析功能
    user_analyse_new_user_income_list: (params) => ajax('get', 'costudy/user/analyse/new_user/income/list', params),
    user_analyse_income_recently_analysis: (params) => ajax('get', 'costudy/user/analyse/income/recently/analysis', params),
    image_shop_sell_recently: (params) => ajax('get', '/figure/image/sell/recently', params),
    
    // 成衣铺套装
    suit_shop_all_records: (params) => ajax('get', '/figure/suit/shop/all/records', params, null),
    suit_shop_sort_top: (params) => ajax('post', '/figure/suit/shop/sort/top', params),
    suit_shop_user_content: (params) => ajax('get', '/figure/suit/shop/user/content', params),
    suit_shop_create: (params) => ajax('post', '/figure/suit/shop/create', params),
    suit_shop_check: (params) => ajax('get', '/figure/suit/shop/check', params),
    suit_shop_update_record: (params) => ajax('post', '/figure/suit/shop/update/record', params, null, {}, true),
    suit_shop_recommend_clothes_init: (params) => ajax('get', '/figure/recommend/clothes/suit/init', params),
    
    // 成衣铺-人设馆
    figure_role_create: (params) => ajax('post', '/figure/role/create', params, null, {}, true),
    figure_role_list: (params) => ajax('get', '/figure/role/list', params, null),
    figure_role_update: (params) => ajax('post', '/figure/role/update', params, null, {}, true),

    // 成衣铺-形象审核
    figure_review_clothes_list: (params) => ajax('get', '/figure/review/clothes/list', params),
    figure_review_clothes_status_update: (params, timeout = 30000) => ajax('post', '/figure/review/clothes/status/update', params, null, {}, true, timeout),
    figure_review_clothes_status_putaway: (params) => ajax('post', '/figure/review/clothes/putaway', params, null, {}, true),
    figure_review_clothes_title_check: (params) => ajax('get', '/figure/review/clothes/title/check', params),

    // CoTime辅助功能
    co_time_tool_user_info: (params) => ajax('get', '/cotime_user/info', params),
    co_time_tool_user_captcha: (params) => ajax('get', '/cotime_user/sms_code/record', params),
    co_time_tool_user_control_password_reset: (params) => ajax('post', '/cotime_user/control_password/reset', params),
    
    // CoTime举报审核
    co_time_report_list: (params) => ajax('get', '/cotime_report/list', params),
    co_time_report_process: (params) => ajax('post', '/cotime_report/handle', params),
    co_time_report_user_detention: (params) => ajax('get', '/cotime_report/user/detention/record', params),
    co_time_report_handle_clear_user_info: (params) => ajax('post', '/cotime_report/handle/clear_user_info', params),
    co_time_report_handle_clear_info: (params) => ajax('post', '/cotime_report/handle/clear_info', params),
    co_time_report_ban_user: (params) => ajax('post', '/v5/cotime_report/ban/user', params, 'study'),
    
    co_time_report_get_user_detention_record: (params) => ajax('get', '/v2/cotime_report/get/user_detention_record', params, 'study'),
    co_time_report_get_be_reporter_last_status: (params) => ajax('get', '/v2/cotime_report/get/be_reporter/last_status', params, 'study'),
    co_time_report_update_detention_record: (params) => ajax('post', '/v2/cotime_report/update/detention_record', params, 'study'),
    
};

export default apis